import React from 'react';
import { useTranslation } from '@gamiphy/react-i18n';
import { Container, Box, Typography } from '@mui/material';
import { LoyaltyPageApi } from '@gamiphy/gamix-modules/loyaltyPage';
import { Faq } from '@gamiphy/bl/faq';
import FaqItem from './FaqItem';
import { useLoyaltyPageContext } from '../../context';

const FaqSection:React.FC = () => {
  const { t } = useTranslation();
  const {
    faqs: faqsQuestions,
    app,
  } = useLoyaltyPageContext();
  const [faqs, setFaqs] = React.useState<Faq[]|undefined>(undefined);

  React.useEffect(() => {
    const fetchLoyaltyFaqs = async () => {
      try {
        const res = await LoyaltyPageApi.getFaqs();

        if (res.length > 0) {
          setFaqs(res);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch faqs:', error);
      }
    };

    if (!faqsQuestions) void fetchLoyaltyFaqs();
  }, []);

  if (!faqs && !faqsQuestions) return null;
  return (
    <Box
      py={{
        xs: 3,
        sm: 5,
      }}
      bgcolor="#fff"
    >
      <Container
        maxWidth="lg"
      >
        <Typography variant="h1" gutterBottom sx={{ textAlign: 'center' }}>
          {t('loyaltyPage.faq.title', 'Frequently asked questions')}
        </Typography>
        <Typography variant="body2" align="center">
          {t('loyaltyPage.faq.subtitle', 'Can’t find the answer you’re looking for ? Reach out to customer support team.')}
        </Typography>

        <Box pt={{
          xs: 4.5,
          sm: 9,
        }}
        >
          {
            (faqsQuestions || faqs)?.map((item:Faq, index) => (
              <FaqItem
                key={item.id ? item.id : `${item.question.en}-${index}`}
                app={app}
                data={item}
              />
            ))
         }
        </Box>
      </Container>
    </Box>
  );
};

export default FaqSection;
